import { Component } from '@angular/core';

@Component({
    selector: 'ui-toolbar-buttons',
    styles: [
        `
        :host {
            display: flex;
            flex: 1;
            flex-wrap: wrap;
            justify-content: flex-end;
            align-items: center;
        }
        `,
    ],
    template: `
        <ng-content></ng-content>
    `
})
export class ToolbarButtonsComponent {}
